(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacePositionsDialogController', RacePositionsDialogController);

    RacePositionsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RacePositions', 'RunnerRaceResume'];

    function RacePositionsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RacePositions, RunnerRaceResume) {
        var vm = this;

        vm.racePositions = entity;
        vm.clear = clear;
        vm.save = save;
        vm.runnerraceresumes = RunnerRaceResume.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.racePositions.id !== null) {
                RacePositions.update(vm.racePositions, onSaveSuccess, onSaveError);
            } else {
                RacePositions.save(vm.racePositions, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:racePositionsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
